import type { QuickOrderListProduct } from "./ProductLine";
import type { Distributor } from "./Distributor";

export enum ListType {
  DistributorFilter = "distributor_filter",
  IntegratedDistributorOrderHistory = "integrated_distributor_order_history",
  MySavedProducts = "my_saved_products",
  ApprovedProducts = "approved_products",
  PreviouslyOrdered = "previously_ordered",
  RecentlyOrdered = "recently_ordered",
  Sculpture = "sculpture",
  UserCreated = "user_created",
}

export enum ProtectedListName {
  IntegratedDistributorOrderHistory = "Order History from Your Distributors",
  MySavedProducts = "My saved products",
  ApprovedProducts = "Approved products",
  PreviouslyOrdered = "Previously Ordered",
  RecentlyOrdered = "Recently Ordered",
  SculptureProducts = "Sculpture Products",
}

export interface ProductSample {
  id: number;
  product_line: {
    id: number;
    name: string;
    image_version: number;
    image_name: string;
    cloudinary_image_url: string;
    manufacturer_id: number;
    product_type_id: number;
  };
}

export interface QuickOrderListIndex {
  allow_editing_of_auto_generated: boolean;
  auto_generated: boolean;
  distributor_list: boolean;
  id: number;
  limited_ordering: boolean;
  name: string;
  position: number;
  products_sample: ProductSample[];
  retailer_id: number;
  retailer_list: boolean;
  list_type?: string; // Remove optional declaration after Previously Ordered merge
}

export interface QuickOrderListDetail {
  allow_editing_of_auto_generated: boolean;
  auto_generated?: boolean | null;
  full_count: number;
  id: number;
  limited_ordering: boolean;
  name: string;
  position: number;
  quick_order_list_products: QuickOrderListProduct[];
  retailer_id: number;
  for_sculpture_retailer: boolean;
  sculpture_retailer_id: number | null;
  sculpture_report_date: number | null;
  retailer?: {
    id: number;
    name: string;
    limited_ordering: boolean;
  };
  loading?: boolean;
  listType: ListType;
  list_type?: ListType; // will be provided by service in planned release
}

export interface QuickOrderList {
  id: number;
  name: string;
  limited_ordering?: boolean;
  source_list_id: number;
  full_count: number;
  quick_order_list_products: QuickOrderListProduct[];
}

export interface QuickOrderListFilters {
  categories: {
    id: number;
    name: string;
    product_type_id: number;
  }[];
  containers: string[];
  smartFilterDistributors?: {
    id: number;
    name: string;
  }[];
  distributors: Distributor[];
  productTypes: {
    id: number;
    name: string;
    case: boolean;
    unit: boolean;
  }[];
  subcategories: {
    id: number;
    name: string;
    category_id: number;
  }[];
}

export interface QuickOrderListParams {
  category: string;
  container: string;
  direction: string;
  distributor: string;
  listId: number;
  page: number;
  product_type: number;
  search: string;
  sort: string;
  subcategory: number;
}

export interface QuickOrderListSmartFilter {
  label: string;
  items: {
    id: number;
    label: string;
    selected: boolean;
    linkParams: QuickOrderListParams;
  }[];
}

export interface QuickOrderListAdParams {
  category_id: number[];
  distributor_ids: number[];
  search?: string;
}
